// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"base-station"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12ZM12 12V22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4.92991 3.92969C1.02467 7.83493 1.02467 14.1666 4.92991 18.0718M8.1114 7.11133C5.96352 9.25921 5.96352 12.7416 8.1114 14.8895M15.8887 7.11133C18.0366 9.25921 18.0366 12.7416 15.8887 14.8895M19.0703 3.92969C22.9756 7.83493 22.9756 14.1666 19.0703 18.0718","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BaseStationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'base-station',
    ref,
    icon: element,
  },
));

BaseStationIcon.displayName = 'BaseStationIcon';

export default BaseStationIcon;
